import logger, { Logger } from 'console-log-level'
import SepaDataService from 'shared/services/api/SepaDataService'
import store from 'shared/store'

// Services
import ClientAPIService from 'shared/services/api/ClientAPIService'
import ClientFockService from 'shared/services/api/ClientFockService'
import AddressService from 'shared/services/api/AddressService'
import CartService from 'shared/services/api/CartService'
import CheckoutService from 'shared/services/api/CheckoutService'
import PaymentService from 'shared/services/api/PaymentService'
import ShippingService from 'shared/services/api/ShippingService'
import AddressSuggestService from 'shared/services/api/AddressSuggestService'
import ProductService from 'shared/services/api/ProductService'
import ProductRatingService from 'shared/services/api/ProductRatingService'

import SellerService from 'shared/services/api/SellerService'
import RedPointsService from 'shared/services/api/RedPointsService'
import OrdersService from 'shared/services/api/OrdersService'
import MiraklService from 'shared/services/api/MiraklService'

type ClientServices = {
  clientAPIService: ClientAPIService
  clientFockService: ClientFockService
  addressService: AddressService
  sellerService: SellerService
  shippingService: ShippingService
  cartService: CartService
  checkoutService: CheckoutService
  addressSuggestService: AddressSuggestService
  paymentService: PaymentService
  sepaDataService: SepaDataService
  ordersService: OrdersService
  redPointsService: RedPointsService
  miraklService: MiraklService
}

type ServiceParams = {
  tenant: string
  locale: string
  logger: Logger
  language: string
  coreShopEnvironment: string
  contentTypeJSON: boolean
}

let clientAPI: ClientServices

const buildClientAPI = (): ClientServices => {
  if (clientAPI) {
    return clientAPI
  }

  const {
    pageProperties,
    publicConfig: {
      api: { baseURL },
      tenant,
      language,
      searchConfig,
      locale
    }
  } = store.getPublicRuntimeConfig()

  const serviceParamsCommon: ServiceParams = {
    tenant,
    coreShopEnvironment: pageProperties.coreShopEnvironment,
    locale,
    contentTypeJSON: true,
    language,
    logger: logger({ level: 'warn' })
  }

  const webClientBaseUrl: string = '/webclient/'
  const apiBaseUrl: string = `${webClientBaseUrl}api`

  clientAPI = {
    clientAPIService: new ClientAPIService({
      ...serviceParamsCommon,
      baseURL,
      searchConfig
    }),
    clientFockService: new ClientFockService({
      ...serviceParamsCommon,
      baseURL: webClientBaseUrl
    }),
    addressService: new AddressService({
      ...serviceParamsCommon,
      baseURL
    }),
    sellerService: new SellerService({
      ...serviceParamsCommon,
      baseURL
    }),
    shippingService: new ShippingService({
      ...serviceParamsCommon,
      baseURL
    }),
    cartService: new CartService({
      ...serviceParamsCommon,
      baseURL: apiBaseUrl
    }),
    checkoutService: new CheckoutService({
      ...serviceParamsCommon,
      baseURL
    }),
    addressSuggestService: new AddressSuggestService({
      ...serviceParamsCommon
    }),
    paymentService: new PaymentService({
      ...serviceParamsCommon,
      baseURL: apiBaseUrl
    }),
    sepaDataService: new SepaDataService({
      ...serviceParamsCommon,
      baseURL: apiBaseUrl
    }),
    ordersService: new OrdersService({
      ...serviceParamsCommon,
      baseURL: apiBaseUrl
    }),
    redPointsService: new RedPointsService({
      ...serviceParamsCommon,
      baseURL
    }),
    productService: new ProductService({
      ...serviceParamsCommon,
      baseURL
    }),
    productRatingService: new ProductRatingService({
      ...serviceParamsCommon,
      baseURL
    }),
    miraklService: new MiraklService({
      ...serviceParamsCommon,
      baseURL: apiBaseUrl
    })
  }
  return clientAPI
}

export default buildClientAPI
